import {useTranslation} from 'react-i18next'

import {UIKIT_NAMESPACE} from '../consts'

export const useUikitTranslation = () => useTranslation(UIKIT_NAMESPACE)
